<template>
  <span>
    <v-editor
      v-if="teacherId"
      :partnerId="teacherId"/>
    <!-- <v-front-editor
      :partnerId="teacherId">
    </v-front-editor> -->
  </span>
</template>

<script>
import VEditor from '@/components/organisms/editor/VEditor'
import VFrontEditor from '@/components/organisms/editor/VFrontEditor'

export default {
  components: {
    VEditor,
    VFrontEditor
  },
  data () {
    return {
      index: null,
      teacherId: ""

    }
  },
  created () {
    this.index = this.$route.params.index
    this.teacherId =  this.$store.getters.parent.getTeacherIds()[this.index]
  }
}
</script>

<style scoped>

</style>
